import React from "react";
import Sidebar from "../../components/Super Admin/SideBar/Sidebar";
import TopTab from "../../components/Super Admin/TopBar/TopbarCoreFunctions";
import SlotTemplateTable from '../../components/Super Admin/Core Functions/SlotTempletTable';
import "../../css/SlotDesignPage.css";

const SlotDesignPage: React.FC = () => {
  return (
    <>
        <TopTab />

          <SlotTemplateTable />
    
        </>

  );
};

export default SlotDesignPage;
